<template>
  <div class="iv-difficult-apply iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width iv-p-b-40">
      <LayoutTitle title="困难申请信息">
        <FormLayout :readOnly="type == 'see'" ref="FormLayout" :model="personInfo" :list="personForm"></FormLayout>
      </LayoutTitle>
      <LayoutTitle class="iv-m-t-24" title="家庭成员信息" :showBtn="type != 'see'" btnText="添加家庭成员" @on-click="addPrize">
        <DragTable
          class="iv-m-t-24"
          noSearch
          :showSelect="false"
          ref="DragTable" 
          :immediateForce="true" 
          :columns="column"
          :showPage="false"
          :showEdit="false"
          :showDelete="type != 'see'"
          :tableData="tableData">
        </DragTable>
      </LayoutTitle>
      <LayoutTitle v-if="type == 'see'" title="困难认定信息">
        <FormLayout ref="FormLayout1" :model="personInfo" :list="cognizance"></FormLayout>
      </LayoutTitle>
    </div>
    <RepeatModal ref="repeat" @on-confirm="confirmSelect"></RepeatModal>
    <FooterOperator>
      <div class="iv-text-center">
        <Button class="iv-m-r-8" type="submit" v-if="type != 'see'" @click="submit">提交申请</Button>
        <Button class="iv-m-r-8" type="save" v-if="type != 'see'" @click="save()">保存</Button>
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import column from './column.js'
import { timeFormat } from '@/utils'
import RepeatModal from './repeat'
import personForm from './person.js'
import cognizance from './cognizance.js'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'
import { addPoor, reportPoor, getPoor } from '../interface/index.js'

export default {
  data () {
    return {
      personInfo: {},
      personForm: [],
      tableData: [],
      groupId: '',
      dictMap: {},
      column: []
    }
  },
  async created () {
    this.type = this.$decode(this.$route.query.type)
    this.yearPoorId = this.$decode(this.$route.query.yearPoorId)
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode)
    this.groupId = this.getUuid()
    this.personForm = personForm.call(this)
    this.cognizance = cognizance.call(this)
    this.getCodeTable('DM14')
    this.getCodeTable('DM15')
    this.getCodeTable('DM33')
    // this.getCodeTable('DM16')
    this.getCodeTable('GG16')
    await this.getCodeTable('GB4762')
    //家庭关系
    await this.getCodeTable('BOE73')
    await this.getUserInfo()
    if (this.yearPoorId) {
      this.getDifficultDetail()
    } else {
      await this.getPartyMemberInfo()
      await this.getFullMemberInfo()
    }
    let tou = column.call(this)
    if (this.type == 'see') {
      tou.pop()
    }
    this.column = tou
  },
  provide () {
    return {
      expandParent: (type, item) => {
        this.$methods('repeat', 'open', item)
      },
      deleteItem: (item) => {
        this.tableData.splice(item._index, 1)
        this.computedIncome()
        return Promise.resolve(item)
      }
    }
  },
  methods: {
    //获取困难详情
    getDifficultDetail () {
      getPoor({yearPoorId: this.yearPoorId}).then(({data}) => {
        data.birthday = this.personInfo.birthday
        this.personInfo = { ...data, ...this.personInfo }
        this.personInfo.logYear = this.personInfo.logYear + ''
        this.personInfo.gender = this.personInfo.gender + ''
        this.personInfo.birthday = timeFormat(this.personInfo.birthday)
        this.personInfo.reportDate = timeFormat(this.personInfo.reportDate)
        this.personInfo.joinPartyDate = timeFormat(this.personInfo.joinPartyDate)
        this.$set(this.personInfo, 'education', this.personInfo.education + '')
        this.personInfo.capitaMonthlyIncome = this.personInfo.capitaMonthlyIncome ? +this.personInfo.capitaMonthlyIncome : null
        this.personInfo.familyPopulation = this.personInfo.familyPopulation ? +this.personInfo.familyPopulation : null
        if (this.personInfo.yearPoorFile) {
          this.groupId = this.personInfo.yearPoorFile
          this.getActivityFiles(this.personInfo.yearPoorFile).then((data) => {
            this.$set(this.personInfo, 'uploadFiles', data)
          })
        }
        if (this.personInfo.cpcYearPoorFamilyList) {
          this.tableData = this.personInfo.cpcYearPoorFamilyList.map(item => item)
        }
      })
    },
    //提交
    async submit () {
      await this.save('submit')
      reportPoor({yearPoorId: this.yearPoorId}).then(({data}) => {
        this.$Message.success('提报成功')
        this.back()
      })
    },
    //保存
    save (status) {
      return new Promise((resolve, reject) => {
        this.$refs['FormLayout'].validate((valid) => {
          if (!valid) {
            this.$Message.error('表单校验失败')
            return
          }
          addPoor({
            yearPoorId: this.yearPoorId,
            ...this.personInfo,
            logYear: timeFormat(this.personInfo.logYear, 'yyyy'),
            yearPoorFile: this.groupId,
            cpcYearPoorFamilyList: this.tableData
          }).then(({data}) => {
            this.yearPoorId = data.yearPoorId || this.yearPoorId
            if (!status) {
              this.$Message.success('保存成功')
            }
            resolve()
          })
        })
      })
    },
    //获取用户信息
    getUserInfo () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/uuminfo/getUserInfo',
          method: 'get',
          data: {}
        }).then(({data}) => {
          const userInfo = data.data
          // let political = ''
          // Object.keys(this.dictMap['GB4762']).forEach(val => {
          //   if (userInfo.polity && this.dictMap['GB4762'][val] == userInfo.polity) {
          //     political = val
          //   }
          // })
          this.personInfo = {
            logYear: userInfo.logYear ? userInfo.logYear + '' : timeFormat(new Date(), 'yyyy'),
            capitaMonthlyIncome: null,
            familyPopulation: null,
            username: userInfo.userName,
            userId: userInfo.userId,
            userCode: userInfo.userCode,
            phone: userInfo.mobile,
            email: userInfo.email,
            gender: userInfo.sex == '女' ? '2' : '1',
            political: userInfo.polity,
            applyType: '01',
            createTime: timeFormat(new Date()),
            reportDate: timeFormat(new Date()),
            idCardNum: userInfo.idCardNum,
            birthday: timeFormat(userInfo.birthday),
            nation: userInfo.nationnality,
            familyAddr: userInfo.familyAddress,
            education: userInfo.highestEducation
          }
          resolve()
        })
      })
    },
    //党员信息
    getPartyMemberInfo () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/byUserIdPink',
          method: 'get',
          data: {
            bizLineCode: 'YWX01'
          }
        }).then(({data}) => {
          // 入党时间、所在党支部名称、党内职务
          const partyMemberInfo = data.data || {}
          let str = ''
          if (partyMemberInfo.partyDuty) {
            for (var key in partyMemberInfo.partyDuty) {  
              str += ',' + partyMemberInfo.partyDuty[key]
            }
            this.personInfo.partyDuty = str.slice(1)
          } else {
            this.personInfo.partyDuty = ''
          }
          this.personInfo.joinPartyDate = timeFormat(partyMemberInfo.joinPartyDate)
          this.personInfo.isFloatPartyMember = partyMemberInfo.isFloatPartyMember + ''
          this.$set(this.personInfo, 'orgName', partyMemberInfo.orgName)
          resolve()
        })
      })
    },
    //会员信息
    getFullMemberInfo () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/byUserIdPink',
          method: 'get',
          data: {
            bizLineCode: 'YWX03'
          }
        }).then(({data}) => {
          //所在工会名称、工会职务
          const fullMemberInfo = data.data ? data.data : {}
          let str = ''
          if (fullMemberInfo.partyDuty) {
            for (var key in fullMemberInfo.partyDuty) {  
              str += ',' + fullMemberInfo.partyDuty[key]
            }
            this.personInfo.ghDuty = str.slice(1)
          } else {
            this.personInfo.ghDuty = ''
          }
          this.$set(this.personInfo, 'ghName', fullMemberInfo.orgName)
          resolve()
        })
      })
    },
    //弹框确定
    confirmSelect (item) {
      let obj = this.tableData.find(_ => (_.uuId == item.uuId))
      if (obj) {
        this.tableData[item._index] = item
      } else {
        item.uuId = this.getUuid()
        this.tableData.push(item)
      }
      this.computedIncome()
    },
    //通过新增家庭成员修改家庭人数和月平均收入
    computedIncome () {
      let totalMoney = 0
      this.tableData.forEach(item => {
        totalMoney += item.monthAvgIncome || 0
      })
      this.$set(this.personInfo, 'familyPopulation', this.tableData.length)
      this.$set(this.personInfo, 'capitaMonthlyIncome', totalMoney / this.tableData.length)
    },
    addPrize () {
      this.$methods('repeat', 'open')
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    back () {
      this.$router.push({
        name: 'difficultList',
        query: {
          currentPage: this.$route.query.currentPage || 1
        }
      })
    }
  },
  components: {
    FormLayout,
    DragTable,
    LayoutTitle,
    RepeatModal,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-difficult-apply {
  min-height: 100%;;
  background-color: #fff;
  /deep/ .ivu-select-input {
    color: rgba(#000000, 0.85) !important;
  }
}
</style>
